import { VpIcon, VpIconSize, VpIconName } from '@vtmn-play/react'
import { HTMLAttributes } from 'react'

type NavBarItemProps = HTMLAttributes<HTMLButtonElement> & {
  label: string
  icon: VpIconName
  onButtonClick: () => void
  iconSize?: VpIconSize
  isActive?: boolean
}

const NavBarItem = ({
  label,
  icon,
  iconSize = 24,
  isActive = false,
  onButtonClick,
  ...props
}: NavBarItemProps) => {
  const textColor = isActive ? 'text-primary-blue font-semibold' : 'text-primary-gray'
  return (
    <button
      {...props}
      type="button"
      className={`w-full flex flex-col items-center justify-center gap-1 ${textColor} p-4`}
      onClick={onButtonClick}
    >
      <VpIcon name={icon} size={iconSize} />
      <span className={`text-xs`}>{label}</span>
    </button>
  )
}

export default NavBarItem
